import { useQuery } from '@tanstack/react-query';
import cms, { CmsRoute, getCmsApiPath } from './cms';

export default function useCms(
  key: string,
  route: CmsRoute,
  params: string[] = []
) {
  const {
    isLoading,
    isError,
    data: query
  } = useQuery({
    queryKey: [key],
    queryFn: () => cms.get(getCmsApiPath(route, params)).then((res) => res.data)
  });

  return {
    isLoading,
    isError,
    query
  };
}

export const RESPONSES = {
  PARAMETER: {
    LOCATIONS: {
      SJI: 'SJI',
      RLH: 'RLH',
      UBN: 'UBN'
    }
  }
};
